import { createQuery } from "react-query-kit";
import { api } from "../../api";
import {
  GetBookingAvailabilityRequest,
  GetBookingAvailabilityResponse,
} from "../../../../../api-contracts/sites/wbe/booking-availability";

// POST /api/public/availability/:siteId
export const useGetBookingAvailability = createQuery<
  GetBookingAvailabilityResponse,
  GetBookingAvailabilityRequest & { siteId: string }
>({
  queryKey: ["useGetBookingAvailability"],
  fetcher: async ({ siteId, from, to, guestCount }) => {
    return api.post<GetBookingAvailabilityResponse>(
      `/api/public/availability/${siteId}`,
      {
        from,
        to,
        guestCount,
      },
    );
  },
});
